// The words of a workspace's first workflow, kept in this tab from Home's or
// the empty list's box through the draft on /workflows/new, so a look at
// another page, a draft left or refused, or a reload loses nothing. They go
// when a workflow exists (the list reads one, api/workflows) and at sign-out,
// not when a session merely expires: the same person signs in again to them.
// New workflow's own copy (editor/start/StartScreen, in localStorage) goes at
// sign-out too.

const PREFIX = "corvus:first-workflow-words:";
const START_SCREEN_PREFIX = "corvus:workflow-start-words:";

export function readFirstWorkflowWords(customerId: string): string {
  try {
    return sessionStorage.getItem(PREFIX + customerId) ?? "";
  } catch {
    return "";
  }
}

export function writeFirstWorkflowWords(customerId: string, words: string) {
  try {
    if (words) sessionStorage.setItem(PREFIX + customerId, words);
    else sessionStorage.removeItem(PREFIX + customerId);
  } catch {
    /* the box still works; the words last until the page goes */
  }
}

/** One workspace's, or with no id every workspace's in this tab (a sign-out). */
export function forgetFirstWorkflowWords(customerId?: string) {
  try {
    const keys = customerId ? [PREFIX + customerId] : Object.keys(sessionStorage).filter((k) => k.startsWith(PREFIX));
    for (const k of keys) sessionStorage.removeItem(k);
    if (!customerId) for (const k of Object.keys(localStorage).filter((k) => k.startsWith(START_SCREEN_PREFIX))) localStorage.removeItem(k);
  } catch {
    /* nothing was kept then */
  }
}
